import "./WarningAlert.scss"

interface WarningAlertProps {
    title: string;
    message: string;
}

const WarningAlert = (props: WarningAlertProps) => {
    return (
        <div className="message-warning">
            <p className="message-warning-title">{props.title}</p>
            <p className="message-warning-message">{props.message}</p>
        </div>
    );
}

export default WarningAlert;